/** @jsxImportSource @emotion/react */

import { connect } from 'unistore/react';
import { css } from '@emotion/react';

import NotifRow from './notifs-row';

import IfElse from '../../../components/IfElse';
import ErrorBoundary from '../../../components/ErrorBoundary';

import { sidebarActions } from '@utils/store/actions';

const SidebarAlerts = ({ sideNotifs, __closeSideNotifs }) => (
	<IfElse
		condition={sideNotifs.length > 0}
		then={sideNotifs.map(notif => (
			<ErrorBoundary key={notif.id}>
				<NotifRow close={__closeSideNotifs} {...notif} />
			</ErrorBoundary>
		))}
		else={
			<li className="py-12 flex items-center flex-col">
				<img
					src="https://bitbns.com/assets/img/empty-notifications.svg"
					className="inline-block"
					alt="Empty"
					css={css`
						height: 80px;
						max-width: 100%;
					`}
				/>
				<div className="font-bold mt-4 text-lightGray">
					None... Ø... Zilch!
				</div>
				<div className="mt-2 text-lavender text-xs">
					Just like Fiat&apos;s backing!
				</div>
			</li>
		}
	/>
);

export default connect('sideNotifs', sidebarActions)(SidebarAlerts);
